import { hasQaLogParam } from "./urlParams";

export const shouldShowCWQALog = (): boolean => {
    const isProduction = window.location.origin === 'https://start.memoryos.com';

    if (isProduction) {
        return hasQaLogParam();
    }

    return true;
};